export function aud(n: number): string {
  return `AUD ${n.toFixed(2)}`;
}

export function minutesLabel(min: number): string {
  const m = Math.max(0, Math.round(min));
  return m < 60 ? `${m} min` : `${Math.floor(m / 60)} h ${m % 60} min`;
}

export function tilesLabel(n: number): string {
  return new Intl.NumberFormat("en-AU").format(Math.round(n));
}

export const SERVICE_LABELS: Record<string, string> = {
  r2ClassA: "R2 writes",
  r2ClassB: "R2 reads",
  r2Storage: "R2 storage (GB-month)",
  workers: "Workers requests",
  durableObjects: "Durable Object requests",
  esriTiles: "Esri tiles",
};

/** Sydney-local short date-time for an ISO instant. `null` is the caller's
 *  own business (an empty string here — `BudgetCard`'s "not yet" and
 *  `EnforcementNotice`'s bare "since" both branch on `null` themselves); an
 *  unparsable string comes back unchanged rather than as "Invalid Date". */
export function sydneyStamp(iso: string | null): string {
  if (iso === null) return "";
  const d = new Date(iso);
  return Number.isFinite(d.getTime())
    ? d.toLocaleString("en-AU", {
        timeZone: "Australia/Sydney",
        dateStyle: "short",
        timeStyle: "short",
      })
    : iso;
}
